module.exports = __webpack_public_path__ + "00_hair.050aa156.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/00_hair.png
// module id = KanU
// module chunks = 0